import _ from 'lodash';

import { validatePatientCaregiver } from 'common-src/models/PatientCaregiver';

import { initialState } from './constants';

export const getInitialFormData = (caregiver, hasActiveCaregivers) => {
  const data = caregiver ? _.pick(caregiver, Object.keys(initialState)) : { ...initialState };

  if (data.phone && data.phone.startsWith('+1')) {
    data.phone = data.phone.substring(2);
  }

  if (!caregiver && !hasActiveCaregivers) {
    data.isPrimary = true;
  }

  return data;
};

export const catchErrors = (data, isGuide) => {
  const errors = {};

  Object.entries(data).forEach(([field, value]) => {
    const err = validatePatientCaregiver(field, value, data, isGuide);
    if (err[field]) {
      Object.assign(errors, { [field]: err[field] });
    }
  });

  return {
    errors,
    hasErrors: !_.isEmpty(errors) || Object.values(errors).some((e) => e),
  };
};

export const getSortedActiveCaregivers = (caregivers = []) =>
  [...caregivers]
    .filter((caregiver) => !caregiver.deletedAt)
    .sort((a, b) => {
      if (a.isPrimary !== b.isPrimary) return Number(b.isPrimary) - Number(a.isPrimary);
      return new Date(b.updatedAt) - new Date(a.updatedAt);
    });

export const getSortedInactiveCaregivers = (caregivers = []) =>
  [...caregivers]
    .filter((caregiver) => caregiver.deletedAt)
    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
